module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer",
    class: _vm.color
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-sm order-sm-3 col-lg social"
  }, _vm._l((_vm.$store.state.links.follow.sublinks), function(link) {
    return _c('a', {
      staticClass: "menu",
      attrs: {
        "href": link.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.name))])
  })), _c('div', {
    staticClass: "col col-sm-6 order-sm-1 order-sm-1 col-lg-auto order-lg-2 contacts"
  }, [(_vm.$store.state.contacts.phone) ? _c('a', {
    staticClass: "phone menu",
    attrs: {
      "href": 'tel:' + _vm.$store.state.contacts.phone.replace(/ +/g, '')
    }
  }, [_vm._v(_vm._s(_vm.$store.state.contacts.phone))]) : _vm._e(), (_vm.$store.state.contacts.email && _vm.$store.state.contacts.email.main) ? _c('a', {
    staticClass: "email menu",
    attrs: {
      "href": 'mailto:' + _vm.$store.state.contacts.email.main
    }
  }, [_vm._v(_vm._s(_vm.$store.state.contacts.email.main))]) : _vm._e()]), _c('div', {
    staticClass: "col-6 col-sm-auto order-sm-2 col-lg-1 order-lg-1 copyright info text"
  }, [_vm._v("© " + _vm._s(_vm.year) + " Sota")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8422b912","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Footer.vue
// module id = 48
// module chunks = 7